module.exports = __webpack_public_path__ + "static/media/schedule-grey.c54df354.svg";